import { createPipeReturn } from './syncPipe';
const throw_ = (predicate, errorCreatorFunc) => (input) => {
    if (!predicate(input)) {
        throw errorCreatorFunc
            ? errorCreatorFunc(input)
            : new Error('Assertion failed');
    }
    return input;
};
const return_ = (predicate, defaultValueSetter) => (input) => {
    if (!predicate(input)) {
        return createPipeReturn(defaultValueSetter(input));
    }
    return input;
};
const boolean_ = (predicate) => (input) => {
    return predicate(input);
};
export const Assert = {
    orThrow: throw_,
    orReturn: return_,
    boolean: boolean_,
    thing: true,
};
//# sourceMappingURL=Assert.js.map